if (!window.athosResultsStateBooted) {
  window.athosResultsStateBooted = true;

  const POLL_MS = 100;
  const GIVE_UP_MS = 6000;

  const apply = (store) => {
    if (!store || !store.loaded || store.error) return;
    const total = store.pagination && store.pagination.totalResults;
    if (typeof total !== "number") return;
    // A PLP filtered down to zero is not a failed search, so the "no results" sections stay hidden.
    // With a query the term itself may match nothing, and those sections are the search fallback.
    const query = store.search && store.search.query && store.search.query.string;
    const filtered = Boolean(store.filters && store.filters.length) && !query;
    document.documentElement.dataset.athosResults =
      total > 0 ? "found" : filtered ? "filtered" : "empty";
  };

  // Filtering re-searches without a page load, so the attribute has to keep following the store.
  const attach = (controller) => {
    apply(controller.store);
    try {
      controller.on("afterStore", (data, next) => {
        apply(controller.store);
        return next();
      });
    } catch (e) {
      return;
    }
  };

  const startedAt = performance.now();
  const poll = setInterval(() => {
    const controller =
      window.athos && window.athos.controller && window.athos.controller.search;
    if (controller) {
      clearInterval(poll);
      attach(controller);
      return;
    }
    if (performance.now() - startedAt > GIVE_UP_MS) clearInterval(poll);
  }, POLL_MS);
}
